import session from './session';

export default {
  getHistory() {
    return session.get('/api/get_uploads_history', { timeout: 50000 });
  },
};



// WEBPACK FOOTER //
// ./src/api/historyTable.js